/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SwapScreenerLeadResidents200ResponseData } from './SwapScreenerLeadResidents200ResponseData';
import {
    SwapScreenerLeadResidents200ResponseDataFromJSON,
    SwapScreenerLeadResidents200ResponseDataFromJSONTyped,
    SwapScreenerLeadResidents200ResponseDataToJSON,
} from './SwapScreenerLeadResidents200ResponseData';

/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200Response
 */
export interface SwapScreenerLeadResidents200Response {
    /**
     * 
     * @type {SwapScreenerLeadResidents200ResponseData}
     * @memberof SwapScreenerLeadResidents200Response
     */
    data?: SwapScreenerLeadResidents200ResponseData;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200Response interface.
 */
export function instanceOfSwapScreenerLeadResidents200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SwapScreenerLeadResidents200ResponseFromJSON(json: any): SwapScreenerLeadResidents200Response {
    return SwapScreenerLeadResidents200ResponseFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SwapScreenerLeadResidents200ResponseDataFromJSON(json['data']),
    };
}

export function SwapScreenerLeadResidents200ResponseToJSON(value?: SwapScreenerLeadResidents200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SwapScreenerLeadResidents200ResponseDataToJSON(value.data),
    };
}

